import styled from "styled-components";
import { ConfirmDialog } from "primereact/confirmdialog";
import { theme } from "../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }
`;

export const CardWrapper = styled.div`
  margin: 15px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};
  gap: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: ${theme.colors.blue900};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: ${theme.colors.gray800};
  }

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const BackHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 15px 0;
`;

export const BackButton = styled.button`
  padding: 8px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: transparent;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  cursor: pointer;

  &:hover {
    border-color: ${theme.colors.primary};
  }
`;

export const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  margin: 0;
`;

export const LayoutSelect = styled.select`
  padding: 6px 12px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: ${theme.colors.blue900};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const MetaInfo = styled.div`
  display: flex;
  gap: 24px;
  padding: 0 15px;
  margin-top: 8px;

  span {
    font-size: 11px;
    color: ${theme.colors.gray800};
    font-family: ${theme.font.poppins};
  }
`;

export const CreateButton = styled.button`
  padding: 10px 24px;
  border-radius: 100px;
  border: none;
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled.button`
  padding: 10px 24px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.red};
  background: transparent;
  color: ${theme.colors.red};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: rgba(235, 87, 87, 0.1);
  }
`;

export const Badge = styled.span<{ $active: boolean }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: ${(p) => (p.$active ? "rgba(76, 175, 80, 0.15)" : "rgba(244, 67, 54, 0.15)")};
  color: ${(p) => (p.$active ? "#4caf50" : "#f44336")};
`;

export const ModeToggle = styled.div`
  display: flex;
  gap: 8px;
`;

export const ModeTab = styled.button<{ $active: boolean }>`
  padding: 10px 20px;
  border-radius: 100px;
  border: 1px solid ${(p) => (p.$active ? theme.colors.primary : theme.colors.gray800)};
  background: ${(p) => (p.$active ? theme.colors.primary : "transparent")};
  color: ${(p) => (p.$active ? theme.colors.white : theme.colors.gray800)};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const SectionCard = styled.div`
  margin: 15px;
  border-radius: 20px;
  padding: 20px;
  background-color: ${theme.colors.darkBlue};
`;

export const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  margin: 0 0 8px 0;
`;

export const InfoBox = styled.div`
  background: rgba(12, 116, 136, 0.1);
  border: 1px solid rgba(12, 116, 136, 0.3);
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  line-height: 1.6;

  code {
    background: rgba(255, 255, 255, 0.1);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${theme.font.poppins};
  font-size: 13px;
  margin-bottom: 12px;

  th, td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  th {
    font-weight: 500;
    color: ${theme.colors.gray800};
    font-size: 11px;
    text-transform: uppercase;
  }

  td {
    color: ${theme.colors.white};
  }

  code {
    background: rgba(255, 255, 255, 0.08);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: ${theme.colors.lightBlue};
  }
`;

export const IconButton = styled.button`
  padding: 6px 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const FormInput = styled.input`
  padding: 10px 14px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: ${theme.colors.blue900};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  outline: none;
  flex: 1;
  min-width: 150px;

  &::placeholder {
    color: ${theme.colors.gray800};
  }

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const FormSelect = styled.select`
  padding: 10px 14px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: ${theme.colors.blue900};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  outline: none;
  min-width: 200px;

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const SmallButton = styled.button`
  padding: 10px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: transparent;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
  }
`;

export const SimulationGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const JsonPreview = styled.pre`
  background: ${theme.colors.blue900};
  color: ${theme.colors.lightBlue};
  border-radius: 12px;
  padding: 16px;
  font-size: 11px;
  line-height: 1.5;
  overflow: auto;
  max-height: 400px;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 12px;
  margin: 15px;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const ConfirmDialogStyled = styled(ConfirmDialog)`
  .p-dialog-header {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-content {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-footer {
    background: ${theme.colors.darkBlue};
    font-family: ${theme.font.poppins};
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;
